import { useLoading } from '../api/hooks';
import { ActionType } from '../redux/actionType';
import { useStickyDiff } from './useStickyDiff';
import { useToggle } from './useToggle';


/**
 * Use this to set a toggle that fires whenever the specified action returns a response (whether success or error).
 *
 * Make sure this is really the behavior you want before using this hook; with very exceptions, you probably want to use
 * `useToggleOnSuccess` in place of this.
 *
 * @param actionType - the type of action to trigger the callback
 * @param requestId - the request Id (if any) of the specific action which should trigger the callback
 */
export const useToggleOnComplete = (
  actionType: ActionType,
  requestId: string | number | undefined = undefined,
): [boolean, () => void] => {
  const [isToggled, setIsToggled] = useToggle();
  const isLoading = useLoading(actionType, requestId);

  useStickyDiff(
    (prev, next) => !!prev?.isLoading && !next.isLoading && setIsToggled(),
    {
      isLoading: isLoading,
    },
  );

  return [isToggled, setIsToggled];
};
